import { b } from './chunk-IMSWER4T.js';

var t=class extends b{URL="uploads";async attachManyUploadsToProduct(o,a){await this._client.post("uploads/attach-many",{product_ids:o,upload_ids:a});}async bulkDeleteUploads(o){await this._client.post("uploads/delete-many",{ids:o});}};

export { t as a };
//# sourceMappingURL=chunk-WTZW4IL6.js.map
//# sourceMappingURL=chunk-WTZW4IL6.js.map